import React from 'react';
import Header from '../components/Header';
import LeftMenu from '../components/LeftMenu';

const GenericPage = ({children, active}) => {
    return (
        <div className='generic-page'>
            <Header / >
            <div className='generic-page-content'>
                <LeftMenu active={active}/>
                <div className='page-content'>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default GenericPage;
